import { all, takeEvery, put, call } from 'redux-saga/effects'
import usersApi from 'services/users'
import { actions } from './actions'

export function* loadUsers({ payload }) {
  const { usersType, search } = payload
  try {
    const response = yield call(usersApi.loadUsers, usersType, search)
    yield put({
      type: actions.LOAD_USERS_RESULT,
      payload: response,
    })
  } catch (error) {
    yield put({
      type: actions.LOAD_USERS_RESULT,
      error,
    })
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD_USERS_REQUEST, loadUsers)])
}
